/**
 * DASHBOARD DO TUTORIAL
 *
 * Exemplo de composição real usando somente as geometrias canônicas dos
 * componentes do EP. MiniDisplay, MetricDisplay e FastChart não são esticados.
 * O espaço variável fica nos charts analíticos, que são naturalmente responsivos.
 */

const dashboardLayout = {
  element: 'dashboard',
  cols: 1,
  rows: 3,
  style: {
    width: '100%',
    height: '100%',
    minWidth: '0',
    minHeight: '0',
  },
  content: [
    {
      element: 'div',
      row: 0,
      col: 0,
      isGrid: false,
      style: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '.625rem',
        width: '100%',
        minWidth: '0',
      },
      content: [
        {
          element: 'miniDisplay',
          label: 'dic.tutorial.dashboard.labels.mrr',
          metrics: [
            {
              subtitle: 'dic.tutorial.dashboard.labels.currentMonth',
              value: 428,
              unit: 'dic.tutorial.dashboard.units.currencyThousands',
              scale: { red: 0, yellow: 350, green: 400 },
            },
          ],
        },
        {
          element: 'miniDisplay',
          label: 'dic.tutorial.dashboard.labels.activeCustomers',
          metrics: [
            {
              subtitle: 'dic.tutorial.dashboard.labels.current',
              value: 184,
              unit: 'dic.tutorial.dashboard.units.customers',
              scale: { red: 0, yellow: 150, green: 175 },
            },
          ],
        },
        {
          element: 'miniDisplay',
          label: 'dic.tutorial.dashboard.labels.pipelineValue',
          metrics: [
            {
              subtitle: 'dic.tutorial.dashboard.labels.current',
              value: 1260,
              unit: 'dic.tutorial.dashboard.units.currencyThousands',
              scale: { red: 0, yellow: 900, green: 1200 },
            },
          ],
        },
        {
          element: 'miniDisplay',
          label: 'dic.tutorial.dashboard.labels.forecastValue',
          metrics: [
            {
              subtitle: 'dic.tutorial.dashboard.labels.current',
              value: 710,
              unit: 'dic.tutorial.dashboard.units.currencyThousands',
              scale: { red: 0, yellow: 550, green: 680 },
            },
          ],
        },
      ],
    },

    {
      element: 'div',
      row: 1,
      col: 0,
      isGrid: false,
      style: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '.625rem',
        width: '100%',
        minWidth: '0',
      },
      content: [
        {
          element: 'chart',
          type: 'line',
          title: 'dic.tutorial.dashboard.labels.revenueForecast',
          legend: 'bottom',
          markers: true,
          style: {
            flex: '1 1 0',
            width: 'auto',
            minWidth: '0',
          },
          xAxis: {
            grid: 'none',
          },
          yAxis: {
            grid: 'soft',
          },
          data: [
            { month: '2026-05-01', revenue: 348, forecast: 356 },
            { month: '2026-06-01', revenue: 362, forecast: 371 },
            { month: '2026-07-01', revenue: 379, forecast: 386 },
            { month: '2026-08-01', revenue: 394, forecast: 403 },
            { month: '2026-09-01', revenue: 411, forecast: 421 },
            { month: '2026-10-01', revenue: 428, forecast: 440 },
          ],
          series: [
            {
              name: 'dic.tutorial.dashboard.series.revenue',
              categoryField: 'month',
              categoryType: 'month',
              valueField: 'revenue',
            },
            {
              name: 'dic.tutorial.dashboard.series.forecast',
              categoryField: 'month',
              categoryType: 'month',
              valueField: 'forecast',
            },
          ],
          options: {
            height: '20.875rem',
          },
        },
        {
          element: 'div',
          isGrid: false,
          style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '.625rem',
            flex: '0 0 auto',
          },
          content: [
            {
              element: 'chart',
              type: 'gauge',
              shape: 1,
              title: 'dic.tutorial.dashboard.labels.sla',
              chartBox: true,
              plotOptions: {
                fast: {
                  min: 0,
                  max: 100,
                  gap: true,
                  ticks: [0, 20, 40, 60, 80, 100],
                  bands: [
                    { from: 0, color: '#ef5a5a' },
                    { from: 85, color: '#e9cf45' },
                    { from: 95, color: '#58c978' },
                  ],
                },
              },
              series: [
                {
                  subtitle: 'dic.tutorial.dashboard.labels.current',
                  value: 96,
                  unit: 'dic.tutorial.dashboard.units.percent',
                  options: {
                    dataLabels: {
                      format: '{value}',
                      fixed: 0,
                    },
                  },
                },
              ],
            },
            {
              element: 'chart',
              type: 'speed',
              skin: 1,
              title: 'dic.tutorial.dashboard.labels.cycleTime',
              chartBox: true,
              plotOptions: {
                fast: {
                  min: 0,
                  max: 80,
                  gap: true,
                  ticks: [0, 20, 40, 60, 80],
                  minorDivisions: 5,
                  bands: [
                    { from: 0, color: '#58c978' },
                    { from: 32, color: '#e9cf45' },
                    { from: 48, color: '#ef5a5a' },
                  ],
                },
              },
              series: [
                {
                  subtitle: 'dic.tutorial.dashboard.labels.current',
                  value: 28,
                  unit: 'dic.tutorial.dashboard.units.hours',
                  options: {
                    dataLabels: {
                      format: '{value}',
                      fixed: 0,
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    {
      element: 'div',
      row: 2,
      col: 0,
      isGrid: false,
      style: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '.625rem',
        width: '100%',
        minWidth: '0',
      },
      content: [
        {
          element: 'div',
          isGrid: false,
          style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '.625rem',
            flex: '0 0 auto',
          },
          content: [
            {
              element: 'metricDisplay',
              label: 'dic.tutorial.dashboard.labels.commercialEfficiency',
              panels: [
                {
                  metrics: [
                    {
                      subtitle: 'dic.tutorial.dashboard.labels.conversionRate',
                      value: 23.4,
                      unit: 'dic.tutorial.dashboard.units.percent',
                      scale: { red: 0, yellow: 18, green: 22 },
                      valuePrecision: 1,
                    },
                    {
                      subtitle: 'dic.tutorial.dashboard.labels.change',
                      value: 2.6,
                      unit: 'dic.tutorial.dashboard.units.percent',
                      scale: { red: -100, common: 0, green: 0.01 },
                      valuePrecision: 1,
                    },
                    {
                      subtitle: 'dic.tutorial.dashboard.labels.previous',
                      value: 20.8,
                      unit: 'dic.tutorial.dashboard.units.percent',
                      valuePrecision: 1,
                    },
                  ],
                },
                {
                  metrics: [
                    {
                      subtitle: 'dic.tutorial.dashboard.labels.averageTicket',
                      value: 18.7,
                      unit: 'dic.tutorial.dashboard.units.currencyThousands',
                      scale: { red: 0, yellow: 15, green: 18 },
                      valuePrecision: 1,
                    },
                    {
                      subtitle: 'dic.tutorial.dashboard.labels.change',
                      value: 7.5,
                      unit: 'dic.tutorial.dashboard.units.percent',
                      scale: { red: -100, common: 0, green: 0.01 },
                      valuePrecision: 1,
                    },
                    {
                      subtitle: 'dic.tutorial.dashboard.labels.previous',
                      value: 17.4,
                      unit: 'dic.tutorial.dashboard.units.currencyThousands',
                      valuePrecision: 1,
                    },
                  ],
                },
              ],
            },
            {
              element: 'miniDisplay',
              label: 'dic.tutorial.dashboard.labels.commercialFunnel',
              metrics: [
                {
                  subtitle: 'dic.tutorial.dashboard.labels.generated',
                  value: 842,
                  scale: { red: 0, yellow: 650, green: 800 },
                },
                {
                  subtitle: 'dic.tutorial.dashboard.labels.qualified',
                  value: 316,
                  scale: { red: 0, yellow: 250, green: 300 },
                },
              ],
            },
            {
              element: 'miniDisplay',
              label: 'dic.tutorial.dashboard.labels.commercialResult',
              metrics: [
                {
                  subtitle: 'dic.tutorial.dashboard.labels.won',
                  value: 74,
                  scale: { red: 0, yellow: 55, green: 70 },
                },
                {
                  subtitle: 'dic.tutorial.dashboard.labels.conversionRate',
                  value: 23.4,
                  unit: 'dic.tutorial.dashboard.units.percent',
                  scale: { red: 0, yellow: 18, green: 22 },
                  valuePrecision: 1,
                },
              ],
            },
          ],
        },
        {
          element: 'div',
          isGrid: false,
          style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '.625rem',
            flex: '0 0 auto',
          },
          content: [
            {
              element: 'chart',
              type: 'bullet',
              title: 'dic.tutorial.dashboard.labels.revenueGoal',
              chartBox: true,
              series: [
                {
                  subtitle: 'dic.tutorial.dashboard.labels.ytd',
                  name: 'dic.tutorial.dashboard.series.revenue',
                  unit: 'dic.tutorial.dashboard.units.currencyThousands',
                  value: 428,
                  target: 450,
                  options: {
                    fast: {
                      min: 0,
                      max: 500,
                      ticks: [0, 100, 200, 300, 400, 500],
                      bands: [
                        { from: 0 },
                        { from: 320 },
                        { from: 420 },
                      ],
                    },
                    dataLabels: {
                      format: '{value}',
                      fixed: 0,
                    },
                  },
                },
              ],
            },
            {
              element: 'chart',
              type: 'bullet',
              title: 'dic.tutorial.dashboard.labels.pipelineGoal',
              chartBox: true,
              series: [
                {
                  subtitle: 'dic.tutorial.dashboard.labels.current',
                  name: 'dic.tutorial.dashboard.series.pipeline',
                  unit: 'dic.tutorial.dashboard.units.currencyThousands',
                  value: 1260,
                  target: 1500,
                  options: {
                    fast: {
                      min: 0,
                      max: 1600,
                      ticks: [0, 400, 800, 1200, 1600],
                      bands: [
                        { from: 0 },
                        { from: 900 },
                        { from: 1300 },
                      ],
                    },
                    dataLabels: {
                      format: '{value}',
                      fixed: 0,
                    },
                  },
                },
              ],
            },
          ],
        },
        {
          element: 'chart',
          type: 'pie',
          title: 'dic.tutorial.dashboard.labels.channelMix',
          legend: 'bottom',
          stacked: {
            mode: 'split',
          },
          style: {
            flex: '1 1 0',
            width: 'auto',
            minWidth: '0',
          },
          plotOptions: {
            pie: {
              labelMode: 'percentage',
              labels: {
                offset: 6,
                len1: 10,
                len2: 14,
              },
              radius: {
                inner: 44,
                outer: 72,
              },
            },
          },
          dataLabels: {
            fixed: 1,
          },
          data: [
            { channel: 'organic', leads: 356 },
            { channel: 'outbound', leads: 248 },
            { channel: 'partners', leads: 154 },
            { channel: 'events', leads: 84 },
          ],
          series: [
            {
              name: 'dic.tutorial.dashboard.series.leads',
              categoryField: 'channel',
              valueField: 'leads',
              categoryLabels: {
                organic: 'dic.tutorial.dashboard.channels.organic',
                outbound: 'dic.tutorial.dashboard.channels.outbound',
                partners: 'dic.tutorial.dashboard.channels.partners',
                events: 'dic.tutorial.dashboard.channels.events',
              },
            },
          ],
          options: {
            height: '20.875rem',
          },
        },
      ],
    },
  ],
};

export default dashboardLayout;
